import { Modal } from "bootstrap";
import CustomInput from "./component/CustomInput";
import { WaitingScreen } from "./lib/WaitingScreen";
/**
 * 画面初期化イベント
 */
addEventListener("load", () => {
  document.getElementById("forgotPassword")?.addEventListener("click", () => {
    new Modal("#forgetPasswordModal", {
      backdrop: "static", //モーダルの枠外クリックでモーダルを閉じないようにする
      focus: true, //モーダル表示直後、モーダルにフォーカスを当てる
      keyboard: true, //ESCキー押下でモーダルを閉じるようにする
    }).show();
  });

  /**
   * 仮パスワードフォーム送信
   */
  document.getElementById("forgetPasswordButton")!.addEventListener("click", () => {
    submit();
  });

  // メニュー画面遷移時に初期表示するタブの設定を削除
  // （ログイン直後は常に共通タブを表示するため）
  localStorage.removeItem("currentTab");

  // ログインフォームでsubmitされた時に割り込む
  const form = document.getElementById("form") as HTMLFormElement;
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    login();
  });
});

/**
 * ログイン
 */
const login = () => {
  //フロントエンド側だけでデバッグ中の場合、ログイン処理を行わずメニュー画面に遷移
  if (import.meta.env.MODE === "development") {
    location.href = "./menu.html";
    return;
  }
  WaitingScreen.show("ログイン中...");
  (document.getElementById("form") as HTMLFormElement).submit();
};

/**
 * フォーム送信
 */
const submit = () => {
  const requestForm = document.getElementById("forgetPasswordModalForm") as HTMLFormElement;
  const mailDom = document.getElementsByName("forgetPasswordModalMail")[0] as CustomInput;
  const mailHiddenDOM = document.getElementById("forgetPasswordMail") as HTMLInputElement;
  mailHiddenDOM.value = mailDom.getValue();

  WaitingScreen.show("パスワードリセット中...");
  requestForm!.submit();
};
